import './App.css';
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";
import NavBar from "./components/navBar";
import CreditPage from "./pages/credit_page";
import Home from "./pages/home";
import AboutUs from "./pages/about_page";
import {ContactUs} from "./components/contact";
import React from "react";

function App() {
    return (
        <div className="App">
            <NavBar />
            <div className="page-content">
                <Router>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/index.html" element={<Home />} />
                        <Route path="/about_page" element={<AboutUs />} />
                        <Route path="/credit_page" element={<CreditPage />} />
                    </Routes>
                </Router>
            </div>
            <footer id="contact">
                <ContactUs />
            </footer>
        </div>
    );
}


export default App;
